// generated/models/agentProposalStatus.ts
var AgentProposalStatus = {
  pending: "pending",
  declined: "declined",
  applied: "applied",
  failed: "failed"
};

export {
  AgentProposalStatus
};
//# sourceMappingURL=chunk-YUOSEYYT.mjs.map